import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IArchivePlanState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const ArchivePlanEmptyState: IArchivePlanState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
